import React from 'react';
import './Styles.css';
import { useNavigate } from 'react-router-dom';
import ErrorMessage from '../../../Elements/ErrorMessage';
import SecondaryButton from '../../../Elements/ids/Buttons/SecondaryButton';
import PrimaryButton from '../../../Elements/ids/Buttons/PrimaryButton';
import { formatMessage } from '../../../Localization/formatMessage';
import Messages from '../../../Localization/Messages';
import { ResultErrorCode } from '../../../Enums/ResultErrorCode';
import { createServerErrorMessage } from '../../../Helpers/FormInputHelper';

const ErrorMode = ({ errorData, createNewTeam }) => {
  const navigate = useNavigate();

  return (
    <div className="employer-page_employer-error_container">
      {errorData?.code === ResultErrorCode.EmployerNotFound ? (
        <>
          <ErrorMessage message={errorData.message} />
          <div className="employer-page_employer-error_button-container">
            <SecondaryButton
              text={formatMessage(Messages.common_goToSearch)}
              onClickEvent={() => {
                navigate('/');
              }}
            />
            <PrimaryButton
              text={formatMessage(Messages.teamInfo_createNewTeamButton)}
              onClickEvent={() => {
                createNewTeam();
              }}
            />
          </div>
        </>
      ) : (
        <>
          <ErrorMessage message={createServerErrorMessage(errorData.message).message} />
          <div className="employer-page_employer-error_button-container">
            <SecondaryButton
              text={formatMessage(Messages.common_goToSearch)}
              onClickEvent={() => {
                navigate('/');
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ErrorMode;
